import { useState } from 'react';
import { Button, Icon } from '@tecma/ds';
import { useTranslation } from '@tecma/i18n';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import paths from 'routes/routesPaths';
import { Layout } from 'pages/Layout';
import { ContactUsModal } from 'components/ContactUsModal';
import { configurationsActions } from 'store/sagas/configurations/configurations.actions';

import './request-page-sent.scss';

export const RequestPageSent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const handleReturnToPersonalArea = () => {
    dispatch(configurationsActions.initConfigurations());
    // Retry refetch to handle eventual consistency after advance-status.
    window.setTimeout(() => dispatch(configurationsActions.initConfigurations()), 1000);
    window.setTimeout(() => dispatch(configurationsActions.initConfigurations()), 3000);
    navigate(paths.root);
  };

  return (
    <Layout>
      <ContactUsModal isOpen={isContactUsModalOpen} toggleModal={() => setIsContactUsModalOpen(!isContactUsModalOpen)} />
      <div className='request-page-sent'>
        <Icon iconName='check-circle' size='large' />
        <h3 className='request-page-sent-title'>{t('request-sent.title')}</h3>
        <p className='request-page-sent-description'>{t('request-sent.description')}</p>
        <div className='request-page-sent-actions'>
          <Button className='request-page-sent-button' onClick={handleReturnToPersonalArea}>
            {t('request-sent.button-label.return-to-personal-area')}
          </Button>
          <div className='request-page-sent-actions-contact-us'>
            <span>{t('request-sent.button-label.have-questions')}</span>
            <Button className='request-page-sent-button' onClick={() => setIsContactUsModalOpen(true)} link>
              {t('request-sent.button-label.contact-us')}
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};
